import React, { useRef } from 'react';
import { useData } from '../contexts/DataContext';
import { useExameResultado } from '../hooks/useExameResultado';

const fmtData = (iso) => new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

// Lista + upload de resultados de exame anexados a um pedido de exame.
// canUpload=true (app da aluna): permite anexar e remover arquivos.
// canUpload=false (admin): só abrir/baixar o que já foi enviado.
export default function ExameResultados({ exame, alunaId, canUpload = false }) {
  const { enviarResultadoExame, removerResultadoExame } = useData();
  const { uploadResultado, abrirResultado, removerArquivo, uploading } = useExameResultado();
  const inputRef = useRef(null);
  const resultados = exame.resultados || [];

  async function handleFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const resultado = await uploadResultado(alunaId, exame.id, file);
      await enviarResultadoExame(exame.id, resultado);
    } catch (err) {
      alert('Erro ao enviar resultado: ' + err.message);
    }
    e.target.value = '';
  }

  async function handleRemover(r) {
    if (!window.confirm(`Remover "${r.nomeArquivo}"?`)) return;
    await removerArquivo(r.path);
    await removerResultadoExame(exame.id, r.id);
  }

  if (resultados.length === 0 && !canUpload) return null;

  return (
    <div style={{ marginTop: '10px' }}>
      {resultados.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: canUpload ? '10px' : 0 }}>
          {resultados.map(r => (
            <div key={r.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', padding: '8px 12px', background: 'var(--surface-2, rgba(137,91,64,0.06))', borderRadius: '10px', fontSize: '12px' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px', overflow: 'hidden' }}>
                📄 <span style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.nomeArquivo}</span>
                <span style={{ color: 'var(--text-2)', flexShrink: 0 }}>· {fmtData(r.enviadoEm)}</span>
              </span>
              <span style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                <button type="button" onClick={() => abrirResultado(r.path)} style={{ border: 'none', background: 'transparent', color: 'var(--accent)', fontWeight: 600, cursor: 'pointer', fontSize: '12px' }}>Abrir</button>
                {canUpload && <button type="button" onClick={() => handleRemover(r)} style={{ border: 'none', background: 'transparent', color: '#C62828', cursor: 'pointer', fontSize: '12px' }}>✕</button>}
              </span>
            </div>
          ))}
        </div>
      )}

      {canUpload && (
        <>
          <input ref={inputRef} type="file" accept="application/pdf,image/*" onChange={handleFile} style={{ display: 'none' }} />
          <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
            style={{ padding: '8px 14px', background: 'var(--accent)', color: 'var(--btn-text, #fff)', border: 'none', borderRadius: '100px', fontSize: '12px', fontWeight: 600, cursor: uploading ? 'not-allowed' : 'pointer', opacity: uploading ? 0.6 : 1 }}>
            {uploading ? 'Enviando...' : '↑ Enviar resultado (PDF/foto)'}
          </button>
        </>
      )}
    </div>
  );
}
